import React, {FC} from 'react';
import styled from 'styled-components';

import {BoxedInput} from '../../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis, textSelection} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Types.
 */

interface RulesGenericInputProps {
  inputId: string;
  hasError?: boolean;
}

/*
 * Styles.
 */

export const StyledDigitsInput = styled.input`
  font-weight: ${fontWeights.medium};
  text-align: left;
  background: inherit;
  width: 2ch;
  height: 20px;
  margin: 0 2px;
  display: block;
  color: inherit;
  outline: 0;
  border: 0;
  padding: 0;
  ${textSelection()};

  // Disable input number spinner.
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::placeholder {
    color: ${(p) => p.theme.greys.shade50};
  }
`;

export const StyledInput = styled(StyledDigitsInput)`
  width: 100%;
  height: 22px;
  line-height: 22px;
`;

export const StyledNumberLabel = styled.span`
  margin: 0 3px;
  display: inline-block;
`;

const GenericStaticInputDiv = styled.div`
  display: flex;
  flex: 1;

  color: inherit;
  cursor: inherit;
  user-select: none;

  font-size: ${fontSizes.medium};
  line-height: 22px;
  margin: 4px 8px 4px 8px;

  ${ellipsis()};
`;

/*
 * Component.
 */

export const RulesGenericInput: FC<RulesGenericInputProps> = (props) => (
  <BoxedInput isButton hasError={props.hasError} noMargin>
    {() => <GenericStaticInputDiv>{props.children}</GenericStaticInputDiv>}
  </BoxedInput>
);
